<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">Unidades de Medida</h3>
            <md-button class="md-primary" to="/configuracoes/medida/novo">Adicionar nova</md-button>
        </md-toolbar>

        <md-table v-model="searched" md-fixed-header>
            <md-table-empty-state
                md-label="Sem registros"
                :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
                <md-button class="md-primary md-raised" @click="newUser">Create New User</md-button>
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID" md-sort-by="unidadeMedida_id" md-numeric>{{ item.unidadeMedida_id }}</md-table-cell>
                <md-table-cell md-label="Código" md-sort-by="unidadeMedida_codigo">{{ item.unidadeMedida_codigo }}</md-table-cell>
                <md-table-cell md-label="Nome" md-sort-by="unidadeMedida_nome">{{ item.unidadeMedida_nome }}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-primary" :to="`/estoque/medida/editar/${item.unidadeMedida_id}`"><md-icon>edit</md-icon></md-button>
                  <md-button class="md-accent" @click="removeItem(item.unidadeMedida_id)"><md-icon>clear</md-icon></md-button>
                </md-table-cell>
            </md-table-row>
        </md-table>

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>

        <md-dialog-confirm
        :md-active.sync="removeItemDialog"
        md-title="Deseja realmente remover este item?"
        md-confirm-text="Remover"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelDialogRemoveItem"
        @md-confirm="onConfirmDialogRemoveItem" />
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../../../components/main-template.vue'
import { api } from '../../../../services/api'

export default {
    name: 'unidade-medida-list',
    components: {
        mainTemplateVue
    },
    data: () => ({
      removeItemDialog: false,
      idToBeRemoved: null,
      snackMessage: false,
      showSnackMessage: false,
      search: null,
      searched: [],
      unidades: []
    }),
    methods: {
      newUser () {
        window.alert('Noop')
      },

      async getListItem(){
        let req = await api().get('estoque/medida')
        this.searched = req.data.data
      },
      
      removeItem(id){
        this.removeItemDialog = true
        this.idToBeRemoved = id
      },

      async onConfirmDialogRemoveItem(){
        api().delete(`/estoque/medida/${this.idToBeRemoved}`).then(() =>  {
          this.showSnackMessage = true
          this.snackMessage = "Registro removido com sucesso"
          this.getListItem()
        }).catch(() => {
          this.showSnackMessage = true
          this.snackMessage = "Falha ao remover o item, verifique se há itens vinculados a ele e tente novamente."
        })
      },

      onCancelDialogRemoveItem(){
        this.idToBeRemoved = null
        this.removeItemDialog = false
      }
    },
    created () {
      this.getListItem()
    }
}
</script>

<style>
.md-table-head, .md-table-head.md-numeric {
    text-align: left !important;
}

.md-table-cell {
    text-align: left !important;
}
</style>